// Import all the global imports
import './imports';
import './library/common/library.common.helpers.js';
import './library/composite/library.composite.helpers.js';
import './global-pay-me/gpm.CurrencyRatesBoard';
import './global-pay-me/gpm.FormBuilder.BankSearch';
import './global-pay-me/gpm.FormBuilder.PayerIsRemitter';
import './global-pay-me/gpm.FormBuilder.QuoteBox';
import './global-pay-me/gpm.RefundForm';

$(window).ready(function () {
  window.gpm = window.gpm || {
    version: 'gpm: 2021.08.20',
    culture: $('body').data('culture'),
    createOption: function (option) {
      return $('<option>', {
        value: option.Id,
        text: option.Title,
        'data-url': option.Url
      });
    }
  };

  // GlobalPay stuff
  this.quoteBox = $('#RemitterBankCountry').gpmQuoteBox();
  this.bankSearch = $('#BankSearch').gpmBankSearch();
  this.payerIsRemitter = $('#PayerIsRemitter').gpmPayerIsRemitter();
  this.currencyRatesBoard = $('#CurrencyRatesBoard').gpmCurrencyRatesBoard();
  this.refundForm = $('#RefundForm').gpmRefundForm(); //to activate just in form

});
